export default "__VITE_ASSET__DPbVc2gG__"